import * as React from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { MessageCard } from '../../designSystem/Message';
import { useParams } from 'react-router-dom';
import { logout } from '../../api/authClientApi';
import { CommandResult } from '../../amorg-common';
import { errorCodes } from '../../amorg-common';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { Card } from '../../designSystem/Card';
import { confirmUserCreation } from '../../api/userClientApi';
import { PageHeader } from '../../designSystem/PageHeader';

export default function ConfirmCreateUserPage(): JSX.Element
{
    const [state, setState] = React.useState<{hasExecuted:boolean, result?:CommandResult}>(
        {
            hasExecuted:false,
            result:undefined
        }
    );

     const params = useParams<{siteId:string, userId:string, requestId:string}>();

     React.useEffect(() => {
        const getData = async () => {
            const result = await confirmUserCreation(params.siteId, params.userId, params.requestId);
            if(result.isSuccess){
                await logout();
            }
            else{
                console.log(result.errorMessage);
            }
            setState({ hasExecuted:true, result});
		};
		getData();
    }, []);

    

    return (

        <ProtectedPageWrapper requiredPermissions={['CreateUser']}>
            <SingleColumnLayout

                contentContainer={
                    <>
                        <PageHeader headerText="Bekræft oprettelse af bruger" headerStyle="secondary-gray" />

                        <div style={{margin:'30px auto', width:'50%', maxWidth:'600px'}}>
                            
                            <Card variant="outlined">
                                {state.hasExecuted &&
                                    <Result value={state.result as CommandResult} />
                                }
                            </Card>
                        </div>
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}

type ResultProps = { value:CommandResult }
function Result({value: result}:ResultProps):JSX.Element
{
    const messageType = result.isSuccess ? 'success' : 'error';
    return(
        <>
            {result.isSuccess
                ? <MessageCard variant={messageType}>Brugeren er oprettet. Log ind fra hovedmenuen.</MessageCard>
                : getErrorMessage(result.errorMessage)
            }
        </>
    );

    function getErrorMessage(error:errorCodes)
    {
        switch(error){
            case 'invalid_site': 
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_invalid_requestId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_invalid_userId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmUserCreation_no_requests_exist':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Dette kan bl.a. skyldes at der er gået for lang tid siden du forsøgte at oprette brugeren, eller at brugeren allerede er aktiveret..</MessageCard>
            case 'confirmUserCreation_userId_in_use':
                return <MessageCard variant={'error'}>Linket er ikke længere gyldigt. Du kan oprette en ny bruger fra login panelet.</MessageCard>
            case 'confirmUserCreation_email_in_use':
                return <MessageCard variant={'error'}>En bruger er allerede oprettet med den indtastede email addresse.</MessageCard>
            default:
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
        }
    }
}